import { render, staticRenderFns } from "./manage-contributors-modal.vue?vue&type=template&id=015b1c22"
import script from "./manage-contributors-modal.vue?vue&type=script&lang=js"
export * from "./manage-contributors-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports